import {apiDELETE, apiGET, apiPOST} from "./RequestsCore";

/**
 * Deletes the provided media.
 *
 * @param expedient_id
 * @param media_id
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteMedia(expedient_id, media_id) {
    // TODO: Maybe avoid expedient_id because we are not using it
    return await apiDELETE('/api/expedient/' + expedient_id + '/media/' + media_id);
}

/**
 * Attaches the provided media to the provided expedient, deleting it from temporary uploads.
 *
 * @param expedient_id
 * @param media_uuid
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function attachFileToExpedientByUuid(expedient_id, media_uuid) {
    return await apiPOST('/api/expedient/' + expedient_id + '/media/' + media_uuid);
}

/**
 * Sets the media collection value with the provided one.
 *
 * @param expedient_id
 * @param media_id
 * @param collection
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function setMediaCollection(expedient_id, media_id, collection) {
    // TODO: Maybe avoid expedient_id because we are not using it
    return await apiPOST('/api/expedient/' + expedient_id + '/media/' + media_id + '/collection/' + collection);
}

/**
 * Sets the media name value with the provided one.
 *
 * @param expedient_id
 * @param media_id
 * @param name
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function setMediaName(expedient_id, media_id, name) {
    // TODO: Maybe avoid expedient_id because we are not using it
    return await apiPOST('/api/expedient/' + expedient_id + '/media/' + media_id + '/name/' + name);
}

/**
 * Returns all the existing categories for media.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getMediaCategories() {
    return await apiGET('/api/media/categories');
}

/**
 * Force the browser to download the requested media.
 *
 * @param media_id
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function download(media_id) {
    return await apiGET('/api/media/' + media_id + '/download');
}
